/** Pendant zu `<SfDatePicker @bind-Value=Model.Feld … />` samt `<ValidationMessage>`. */

import { DatePicker } from '@/components/ui';

import { asDate, fromDate, type FieldAccess } from './fieldAccess';
import { FormField } from './FormField';

export interface DateFieldProps<T> {
  form: FieldAccess<T>;
  name: keyof T & string;
  /** Beschriftung über dem Feld — Text unverändert aus REQ-10 §3/§4. */
  label: string;
}

export function DateField<T>(props: DateFieldProps<T>) {
  const { form, name } = props;
  const field = form.viewField(name);
  if (field === null) return null;

  return (
    <FormField message={form.message(name)}>
      <DatePicker
        value={asDate(form.value(name))}
        label={props.label}
        readOnly={field.ReadOnly}
        onChange={(value) => {
          form.setValue(name, fromDate(value));
        }}
      />
    </FormField>
  );
}

export default DateField;
